import React from 'react'

export const IconFacebook = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_368_9212)">
      <path
        d="M22 11C22 4.92486 17.0751 0 11 0C4.92486 0 0 4.92486 0 11C0 16.4903 4.02252 21.0412 9.28125 21.8664V14.1797H6.48828V11H9.28125V8.57656C9.28125 5.81969 10.9235 4.29688 13.4361 4.29688C14.6392 4.29688 15.8984 4.51172 15.8984 4.51172V7.21875H14.5114C13.145 7.21875 12.7188 8.06674 12.7188 8.9375V11H15.7695L15.2818 14.1797H12.7188V21.8664C17.9775 21.0412 22 16.4903 22 11Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_368_9212">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
